<!--suppress UnnecessaryLabelJS -->
<template>
	<v-card>
		<v-card-title>
			<v-spacer/>
			<v-spacer/>
			<v-text-field
				v-model="lookingFor"
				append-icon="mdi-magnify"
				label="חיפוש"
				single-line
				hide-details
			></v-text-field>

		</v-card-title>
		<v-data-table
            @update:options="pagination"
			:headers="headers"
			:items="clients"
			:loading="loading"
			:search="lookingFor"
            :server-items-length="serverItemsLength"
			class="elevation-1"
		>
			<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

			<template #item.action="{item}">
				<action-td :item="item" module="client" @edit="onEdit">
					<v-tooltip bottom>
						<template #activator="{ on }">
							<v-btn v-on="on" @click="openCardModal(item)" icon>
								<v-icon>mdi-cash-plus</v-icon>
							</v-btn>
						</template>
						<span>הוספת כרטיסים</span>
					</v-tooltip>
				</action-td>
			</template>
		</v-data-table>
		<popup-dialog v-model="showDialog">
			<span slot="header">יצירת כרטיסים</span>
			<form-builder v-if="showDialog" modelName="card" @save="onSave" module="CardModule" :inputs="cardInputs"/>
		</popup-dialog>
	</v-card>
</template>

<script>

	import {types} from "src/store/modules/Client.module";
	import {types as cardTypes} from "src/store/modules/Card.module";
	import FilterAble from "src/mixins/FilterAble";
	import ActionTd from "src/components/AcationTd";
	import FormBuilder from "../../components/form/FormBuilder";
	import LotteriesSelect from "../lotteries/LotteriesSelect";
	import PackagesSelect from "../packages/PackagesSelect";

	export default {
		name: "clients-table",
		mixins: [new FilterAble(types,true)],
		props: {filterItems:Object},
		components: {
			FormBuilder,
			ActionTd
		},
		data() {
			return {
				loading: false,
				headers: [
					{text: "מזהה לקוח", value: "uuid"},
					{text: "שם", value: "name"},
					{text: "טלפון", value: "tel"},
					{text: "תעודת זהות", value: "id_number"},
					{text: "דואר אלקטרוני", value: "email"},
					{text: "מספר כרטיסים", value: "cards_count"},
					{text: "חבילה", value: "package.title"},
					{text: "utm_source", value: "utm_source"},
					{text: "utm_medium", value: "utm_medium"},
					{text: "utm_content", value: "utm_content"},
					{text: "הגיע משיתוף", value: "share.name"},
					{text: "פעולות", value: "action", sortable: false}
				],
				lookingFor: null,
				showDialog: false,
				cardInputs: [
					{label: "מספר כרטיסים", name: "package_id",   component: PackagesSelect},
					{label: "הגרלה", name: "lottery_id", component: LotteriesSelect},
				],
				currentClient:null
			};
		},
		computed: {
			clients() {
				return this.$store.state.ClientModule.clients;
			},
			client() {
				return this.$store.state.ClientModule.client;
			},
			basicUrl() {
				return this.$store.state.ConfigModule.request.baseUrl;
			},
		},
		methods: {
			onEdit(Client) {
				this.$emit("edit", Client);
			},
			openCardModal(client) {
				this.$store.commit(cardTypes.CREATE, {client_id: client.id});
				this.currentClient=client;
				this.showDialog = true;
			},
			onSave(){
				this.$store.dispatch(types.REFRESH, this.currentClient.id);
				this.showDialog = false;
			},

		},watch:{
            lookingFor(value){
                this.freeSearch(value,
                    ["name","tel","id_number","email"]

                )
            }
        }
	};
</script>

<style>

</style>
